export const PROPOSALS_ROW_DATA_FETCH_REQUESTED = 'PROPOSALS_ROW_DATA_FETCH_REQUESTED'
export const PROPOSALS_ROW_DATA_FETCH_SUCCESS = 'PROPOSALS_ROW_DATA_FETCH_SUCCESS'
export const PROPOSAL_FETCH_SUCCESS = 'PROPOSAL_FETCH_SUCCESS'
export const PROPOSALS_BOARD_ROW_DATA_FETCH_REQUESTED = 'PROPOSALS_BOARD_ROW_DATA_FETCH_REQUESTED'
export const PROPOSALS_BOARD_ROW_DATA_FETCH_SUCCESS = 'PROPOSALS_BOARD_ROW_DATA_FETCH_SUCCESS'
export const PROPOSAL_UPDATE_STATUS_REQUESTED = 'PROPOSAL_UPDATE_STATUS_REQUESTED'
export const PROPOSAL_UPDATE_STATUS_SUCCESS = 'PROPOSAL_UPDATE_STATUS_SUCCESS'
export const CREATE_PROPOSAL_BOARD_TASK_REQUESTED = 'CREATE_PROPOSAL_BOARD_TASK_REQUESTED'
export const CREATE_PROPOSAL_BOARD_TASK_SUCCESS = 'CREATE_PROPOSAL_BOARD_TASK_SUCCESS'
export const USERS_FETCH_REQUESTED = 'USERS_FETCH_REQUESTED'
export const PROPOSAL_TASKS_FETCH_REQUESTED = 'PROPOSAL_TASKS_FETCH_REQUESTED'
export const UPDATE_BOARD_PROPOSAL_TASK_REQUESTED = 'UPDATE_BOARD_PROPOSAL_TASK_REQUESTED'
export const UPDATE_BOARD_PROPOSAL_TASK_SUCCESS = 'UPDATE_BOARD_PROPOSAL_TASK_SUCCESS'
export const PROPOSAL_BOARD_TASK_MARK_COMPLETED_REQUESTED =
  'PROPOSAL_BOARD_TASK_MARK_COMPLETED_REQUESTED'
export const PROPOSAL_BOARD_TASK_MARK_COMPLETED_SUCCESS =
  'PROPOSAL_BOARD_TASK_MARK_COMPLETED_SUCCESS'
export const PROPOSAL_BOARD_TASK_MARK_NOT_COMPLETED_REQUESTED =
  'PROPOSAL_BOARD_TASK_MARK_NOT_COMPLETED_REQUESTED'
export const PROPOSAL_BOARD_TASK_MARK_NOT_COMPLETED_SUCCESS =
  'PROPOSAL_BOARD_TASK_MARK_NOT_COMPLETED_SUCCESS'
export const PROPOSAL_TASK_MARK_COMPLETED_SUCCESS = 'PROPOSAL_TASK_MARK_COMPLETED_SUCCESS'
export const PROPOSAL_TASK_MARK_NOT_COMPLETED_SUCCESS = 'PROPOSAL_TASK_MARK_NOT_COMPLETED_SUCCESS'
export const PROPOSALS_TEMPLATES_FETCH_SUCCESS = 'PROPOSALS_TEMPLATES_FETCH_SUCCESS'
export const PROPOSALS_TEMPLATES_FETCH_REQUESTED = 'PROPOSALS_TEMPLATES_FETCH_REQUESTED'
export const DELETE_BOARD_PROPOSAL_TASK_REQUESTED = 'DELETE_BOARD_PROPOSAL_TASK_REQUESTED'
export const DELETE_BOARD_PROPOSAL_TASK_SUCCESS = 'DELETE_BOARD_PROPOSAL_TASK_SUCCESS'
export const UPDATE_PROPOSAL_PAGINATION_BOARD = 'UPDATE_PROPOSAL_PAGINATION_BOARD'
export const PROPOSALS_BOARD_FOR_USER_FETCH_REQUESTED = 'PROPOSALS_BOARD_FOR_USER_FETCH_REQUESTED'
export const PROPOSALS_LIST_FOR_USER_FETCH_REQUESTED = 'PROPOSALS_LIST_FOR_USER_FETCH_REQUESTED'
export const PROPOSALS_BOARD_FOR_USER_FETCH_SUCCESS = 'PROPOSALS_BOARD_FOR_USER_FETCH_SUCCESS'
export const PROPOSALS_LIST_FOR_USER_FETCH_SUCCESS = 'PROPOSALS_LIST_FOR_USER_FETCH_SUCCESS'
